import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../../utils/pickIf';
import { styleCondition } from '../../../../utils/styleCondition';

import { colors } from '../../../../styles/palette';

const getRoot = (placedOrder, theme) => {
  return {
    position: 'relative',
    borderRadius: 20,
    boxShadow: '0px 5px 15px rgba(44, 112, 172, 0.2)',
    display: 'flex',
    height: pickIf(placedOrder, 231, 275),
    marginBottom: theme.spacing(2.5),
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      height: 298,
    },
    [theme.breakpoints.down('md')]: {
      borderRadius: 10,
      height: 136,
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...styleCondition(theme.isMobileDevice, {
        height: 298,
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        borderRadius: 10,
        height: 136,
        marginBottom: theme.spacing(2),
      }),
    },
  };
};
const getDescAndSize = (theme, reviewOrderPage) => {
  return {
    marginBottom: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    [theme.breakpoints.down('lg')]: {
      marginBottom: 4,
      marginTop: 4,
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(0.5),
      ...(reviewOrderPage && {
        marginBottom: 0,
        marginTop: 0,
      }),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
      marginTop: 0,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...styleCondition(theme.isMobileDevice, {
        marginBottom: 4,
        marginTop: 4,
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        marginBottom: theme.spacing(0.5),
        ...(reviewOrderPage && {
          marginBottom: 0,
          marginTop: 0,
        }),
      }),
    },
  };
};
const getApprovalInfo = (theme) => {
  return {
    color: theme.palette.grey2,
    fontSize: 14,
    position: 'absolute',
    right: 0,
    top: theme.spacing(3.5),
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
      bottom: 8,
      right: 'auto',
      top: 'auto',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        fontSize: 12,
        bottom: 8,
        right: 'auto',
        top: 'auto',
      }),
    },
  };
};
const getSaveLater = (theme) => {
  return {
    backgroundColor: '#F4F4F4',
    fontSize: 12,
    padding: '5px 10px',
    position: 'absolute',
    width: '100px',
    height: '30px',
    right: '75px',
    top: '16px',
    '&:hover': {
      backgroundColor: '#c6cac6 !important',
    },
    [theme.breakpoints.down('lg')]: {
      padding: '2px 10px',
      height: '24px',
      left: 'calc(298px + 20px + 0.6 * (100% - (298px + 20px + 23px + 16px)))',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 10,
      position: 'relative',
      width: '74px',
      height: '20px',
      left: 'auto',
      right: 'unset',
      top: 'unset',
      padding: '0',
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...styleCondition(theme.isMobileDevice, {
        padding: '2px 10px',
        height: '24px',
        left: 'calc(298px + 20px + 0.6 * (100% - (298px + 20px + 23px + 16px)))',
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        fontSize: '10px !important',
        position: 'relative',
        width: '74px',
        height: '20px',
        left: 'auto',
        right: 'unset',
        top: 'unset',
        padding: '0',
      }),
    },
  };
};
export const useStyles = makeStyles()(
  (
    theme,
    { placedOrder, isUnavailableForOrder, reviewOrderPage, isKiteUser } = {},
  ) => ({
    infoIconButton: { marginTop: '3px' },
    accentBold: { color: colors.gilead.primary1, fontWeight: 700 },
    root: getRoot(placedOrder, theme),
    img: {
      ...(isUnavailableForOrder && {
        opacity: 0.65,
      }),
    },
    actionArea: {
      position: 'relative',
      width: 'initial',
    },
    descriptionContainer: {
      paddingRight: '23px',
      flex: 1,
      [theme.breakpoints.down('md')]: {
        flex: 0,
        paddingRight: 'unset',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          flex: 0,
          paddingRight: 'unset',
        }),
      },
    },
    descAndSize: getDescAndSize(theme, reviewOrderPage),
    description: {
      cursor: 'pointer',
      fontSize: 18,
      fontWeight: 700,
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 12,
        }),
      },
    },
    content: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      padding: '16px 16px 30px 30px !important',
      width: '100%',
      minWidth: 150,
      [theme.breakpoints.down('lg')]: {
        gap: theme.spacing(1),
        padding: '16px 16px 40px 20px !important',
      },
      [theme.breakpoints.down('md')]: {
        gap: theme.spacing(0.5),
        padding: '8px !important',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          gap: theme.spacing(1),
          padding: '16px 16px 40px 20px !important',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          gap: theme.spacing(0.5),
          padding: '8px !important',
        }),
      },
    },
    iconsContainer: {
      paddingRight: '23px',
      [theme.breakpoints.down('md')]: {
        paddingRight: 0,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          paddingRight: 0,
        }),
      },
    },
    label: {
      backgroundColor: '#F4F4F4',
      borderRadius: 4,
      color: '#54565B',
      fontSize: 14,
      fontWeight: 600,
      padding: 4,
    },
    removeButton: {
      fontSize: 22,
      position: 'initial',
      zIndex: 'initial',
      [theme.breakpoints.down('md')]: {
        fontSize: 14,
        marginLeft: 'auto',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 14,
          marginLeft: 'auto',
        }),
      },
    },
    saveLater: getSaveLater(theme),
    totalItemsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingRight: '23px',
      [theme.breakpoints.down('lg')]: {
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingRight: 'unset',
        columnGap: 'calc(60% - 130px - 13px)',
        '& #count-button': {
          width: 130,
          paddingTop: '6px',
          paddingBottom: '6px',
        },
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
        alignItems: 'initial',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'space-between',
        columnGap: 0,
        '& #count-button': {
          padding: '1px 6px',
          width: 95,
        },
        '& > div:nth-child(2)': {
          fontSize: 12,
          order: 0,
        },
        '& > div:nth-child(1)': {
          order: 1,
        },
        ...(reviewOrderPage && {
          alignItems: 'initial',
          flexDirection: 'column',
          '& #count-button': {
            padding: '1px 6px',
            width: 95,
          },
          flex: 1,
          '& > div:nth-child(2)': {
            order: 0,
          },
          '& > div:nth-child(1)': {
            order: 1,
          },
        }),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          alignItems: 'center',
          justifyContent: 'flex-start',
          paddingRight: 'unset',
          columnGap: 'calc(60% - 130px - 13px)',
          '& #count-button': {
            width: 130,
            paddingTop: '6px',
            paddingBottom: '6px',
          },
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 12,
          alignItems: 'initial',
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'space-between',
          columnGap: 0,
          '& #count-button': {
            padding: '1px 6px',
            width: 95,
          },
          '& > div:nth-child(2)': {
            fontSize: 12,
            order: 0,
          },
          '& > div:nth-child(1)': {
            order: 1,
          },
          ...(reviewOrderPage && {
            alignItems: 'initial',
            flexDirection: 'column',
            '& #count-button': {
              padding: '1px 6px',
              width: 95,
            },
            flex: 1,
            '& > div:nth-child(2)': {
              order: 0,
            },
            '& > div:nth-child(1)': {
              order: 1,
            },
          }),
        }),
      },
    },
    qtyLabels: {
      color: pickIf(isKiteUser, theme.palette.primary1, theme.palette.primary2),
      fontSize: 14,
      fontWeight: 600,
      [theme.breakpoints.down('lg')]: {
        flexBasis: '40%',
      },
      [theme.breakpoints.down('md')]: {
        flexBasis: 'initial',
        fontSize: pickIf(reviewOrderPage, 10, 12),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          flexBasis: '40%',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          flexBasis: 'initial',
          fontSize: pickIf(reviewOrderPage, 10, 12),
        }),
      },
    },
    totalItems: {
      color: theme.palette.red,
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
      '& #rating': {
        marginRight: '20px',
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',
        justifyContent: 'space-between',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          width: '100%',
          justifyContent: 'space-between',
        }),
      },
    },
    approvalInfo: getApprovalInfo(theme),
    labels: {
      display: 'flex',
      columnGap: theme.spacing(1),
      position: 'absolute',
      left: theme.spacing(2),
      top: theme.spacing(2),
      zIndex: 10,
      [theme.breakpoints.down('md')]: {
        columnGap: theme.spacing(0.75),
        left: theme.spacing(1.25),
        top: theme.spacing(1.25),
      },
    },
  }),
);
